module.exports = __webpack_public_path__ + "img/section5-1-mobile.75f81f1e.png";